import momentGenerateConfig from '@rc-component/picker/es/generate/moment'
import { Calendar as AntCalendar } from 'antd'
import type { Moment } from 'moment-timezone'

export const Calendar = AntCalendar.generateCalendar<Moment>(momentGenerateConfig)
